<template>
  <div class="stationery-add">
    <el-dialog title="新增文具" :visible="addStationeryShow" width="750px" center :close-on-click-modal="false"
      @open="dialogOpen" @close="dialogClose">
      <el-form :inline="true">
        <el-form-item label="名称" required>
          <el-input v-model="ruleForm.itemName" placeholder="请输入" prop="rank"></el-input>
        </el-form-item>
        <el-form-item label="数量" required style="margin-left: 80px">
          <el-input v-model.number="ruleForm.number" placeholder="请输入" prop="rank" type="number" :min="1"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    addStationeryShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ruleForm: {
        itemName: "",
        number: 1,
      },
    };
  },
  inject: ["refresh"],
  methods: {
    dialogOpen() {
      this.ruleForm = {
        itemName: "",
        number: 1,
      };
    },
    dialogClose() {
      this.$emit("update:addStationeryShow", false);
    },
    confirm() {
      let data = {
        schoolId: this.user.schoolId,
        itemName: this.ruleForm.itemName,
        quantity: this.ruleForm.number,
      };
      this.post(this.$url.insertSchoolStationery, data).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.refresh();
          this.dialogClose();
        } else {
          return this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryAdd.scss";
</style>